import React, { useState } from "react";
import { Typography, Form, Row, Col, Input, Divider } from "antd";
import styled from "styled-components";
import AddPhysicianModalWrapper from "../modal/AddPhysicianModalWrapper";
import {
  CustomButton,
  CustomSecondaryButton,
} from "../pages/physician_page/styled";
import { physicianService } from "../../services/user";
import { extractToken } from "../../utils/localStorage";
import moment from "moment";

const { Title, Text, Paragraph } = Typography;

const FormContainer = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  width: 100%;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  .section-title {
    color: var(--primary-text-color);
    margin-bottom: 16px;
    font-size: 18px;
    font-weight: 600;
  }

  .section-content {
    margin-bottom: 24px;
  }

  ul {
    list-style-type: disc;
    padding-left: 20px;
    margin-bottom: 16px;
  }

  li {
    margin-bottom: 8px;
    color: var(--primary-text-color);
  }
`;

const TermAndCondition = ({ isOpen, setOpen, getMyProfile, profileData }) => {
  const [loding, setLoding] = useState(false);

  const user = extractToken();
  const userId = user?.sub;

  const handleConsentAccept = async (values) => {
    try {
      setLoding(true);
      const res = await physicianService.handleConsentAccept(userId, {
        consentAccept: true,
        consentName: values.consentName,
      });
      getMyProfile();
      setOpen(false);
    } catch (error) {
      setLoding(false);
    }
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <AddPhysicianModalWrapper
      isOpen={isOpen}
      setShow={onClose}
      show={true}
      title={
        <div className="row-flex flex-column">
          <h3 className="font-18 font-semibold text-primary mb-5">
            VOICE USAGE CONSENT FORM
          </h3>
          <span className="font-15 text-secondry">
            Meducate AI — Limited Use Agreement
          </span>
        </div>
      }
      footer={null}
      width={600}
      keyClose={false}
      className="custom-detail-modal"
    >
      <Form layout="vertical" onFinish={handleConsentAccept}>
        <FormContainer>
          <Row>
            {(profileData && !profileData.consentAccept) && (
            <Col span={24}>
              <Form.Item
                name="consentName"
                label="Full Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter your name!",
                  },
                ]}
              >
                <Input placeholder="Enter Full Name" size="large" />
              </Form.Item>
            </Col>
            )}
            <Col span={24}>
              <div className="agreement-intro" style={{ marginBottom: "24px" }}>
                <Text className="text-primary">
                  This Consent Form ("Agreement") is entered into by and between
                  Meducate AI, LLC, an Alabama limited liability company
                  ("Meducate"), and the undersigned individual ("Doctor" or
                  "You").
                </Text>
              </div>

              <div className="section-content">
                <Title level={4} className="section-title">
                  1. Purpose
                </Title>
                <Paragraph className="text-primary">
                  You agree to allow Meducate to use recordings of your voice
                  for the sole purpose of producing and distributing educational
                  videos in the Meducate AI video library within the Meducate
                  platform.
                </Paragraph>
              </div>

              <div className="section-content">
                <Title level={4} className="section-title">
                  2. Scope of Use
                </Title>
                <ul>
                  <li>
                    Voice recordings will be used exclusively in educational
                    video content for the specified library associated with your
                    medical specialty.
                  </li>
                  <li>
                    Your voice will not be used in any promotional, marketing,
                    or unrelated content without your additional written
                    consent.
                  </li>
                  <li>
                    Meducate will not sell, license, lease, or otherwise use
                    your voice for any third-party use or AI training beyond the
                    stated educational purpose.
                  </li>
                </ul>
              </div>

              <div className="section-content">
                <Title level={4} className="section-title">
                  3. Ownership
                </Title>
                <ul>
                  <li>You retain all rights to your voice and likeness.</li>
                  <li>
                    Meducate retains all rights to the educational content it
                    creates using your voice, provided it adheres to the
                    limitations of this Agreement.
                  </li>
                </ul>
              </div>

              <div className="section-content">
                <Title level={4} className="section-title">
                  4. Confidentiality and Representation
                </Title>
                <Paragraph className="text-primary">
                  Meducate will not attribute medical advice or statements to
                  you outside of the context of the agreed-upon educational
                  scripts and recordings. You represent that your contributions
                  do not violate any contractual or institutional obligations.
                </Paragraph>
              </div>

              <div className="section-content">
                <Title level={4} className="section-title">
                  5. Termination
                </Title>
                <Paragraph className="text-primary">
                  You may revoke your consent with 30 days' written notice.
                  Meducate will cease using your voice in any new content and
                  may archive or disable existing videos at its discretion.
                </Paragraph>
              </div>

              <div className="section-content">
                <Title level={4} className="section-title">
                  6. Governing Law
                </Title>
                <Paragraph className="text-primary">
                  This Agreement shall be governed by and construed in
                  accordance with the laws of the State of Alabama.
                </Paragraph>
              </div>

              <div>
                <Divider style={{margin: "10px 0"}} />
              </div>

            {(profileData && profileData.consentAccept) && (
              <>
              <div className="d-flex justify-start">
                <span className="font-16 font-semibold mr-5 text-primary">
                  Name:
                </span>
                <span className="text-primary">
                  {profileData?.consentName}
                </span>
              </div>
              <div className="d-flex justify-start">
                <span className="font-16 font-semibold mr-5 text-primary">
                  Email:
                </span>
                <span className="text-primary">
                  {profileData?.email}
                </span>
              </div>
              <div className="d-flex justify-start">
                <span className="font-16 font-semibold mr-5 text-primary">
                  Date:
                </span>
                <span className="text-primary">
                  {moment(profileData?.consentTimestamp).format("DD MMM YYYY hh:mm A")}
                </span>
              </div>
              </>
            )}
            </Col>
          </Row>
        </FormContainer>
      {(profileData && !profileData.consentAccept) && (
        <Row className="mt-16">
          <Col span={24} className="d-flex justify-end gap-12">
            <CustomSecondaryButton onClick={() => setOpen(false)}>
              Cancel
            </CustomSecondaryButton>
            <CustomButton htmlType="submit">Accept</CustomButton>
          </Col>
        </Row>
        )}
      </Form>
    </AddPhysicianModalWrapper>
  );
};

export default TermAndCondition;
